var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 406,
    height: 406,
    viewBox: "0 0 406 406",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4797 202.967C21.4797 102.734 102.734 21.4798 202.967 21.4798C303.199 21.4798 384.454 102.734 384.454 202.967C384.454 303.199 303.199 384.454 202.967 384.454C102.734 384.454 21.4797 303.199 21.4797 202.967ZM202.967 0.138C90.9475 0.138 0.137939 90.9475 0.137939 202.967C0.137939 314.986 90.9475 405.796 202.967 405.796C314.986 405.796 405.796 314.986 405.796 202.967C405.796 90.9475 314.986 0.138 202.967 0.138ZM139.314 172.342L177.746 171.741C177.991 165.362 177.986 159.358 177.981 153.669C177.962 131.512 177.946 114.126 192.758 97.8804C207.843 81.1791 231.629 82.8455 257.61 84.6657C260.588 84.8743 263.594 85.0849 266.619 85.2701V120.699C263.64 120.835 260.854 120.936 258.25 121.031C226.218 122.198 221.763 122.36 223.984 172.342H264.818L258.212 215.577H223.984V321.865H177.746L177.146 215.577H138.714L139.314 172.342Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f32dd8b1eec017ae5374443970fe180a.svg";
export { ForwardRef as ReactComponent };